import Vue from 'vue'
import Vuex from 'vuex'
//持久化插件
import createPersistedstate from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    pathName: '',
    title: 'Marriage Appointment',
    userLoadStatus: false, // false--未登录 true--登录
    userName: '', // 用户名
    idcard: '',   // 身份证号
    tel:''        //手机号
  },
  mutations: { // 验证是否登录成功
    updateInfo (state, userInfo) {
      state.userName = userInfo.username
      state.idcard = userInfo.idcard
      state.tel = userInfo.tel
    },
    //更新用户已登录
    sotreLoginStatus(state, flag){
      // console.log(flag)
      state.userLoadStatus = flag
    }
  },
  //保持state
  plugins:[createPersistedstate({
    storage:window.sessionStorage
  })]
})



// WEBPACK FOOTER //
// ./src/store/index.js